interface DocumentIconProps {
  className?: string
  selected?: boolean
}

export function DocumentIcon({ className = '', selected = false }: DocumentIconProps) {
  return (
    <div className={`overflow-clip size-[16px] ${className}`}>
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M10 1.33334H4C3.64638 1.33334 3.30724 1.47382 3.05719 1.72386C2.80714 1.97391 2.66667 2.31305 2.66667 2.66668V13.3333C2.66667 13.687 2.80714 14.0261 3.05719 14.2762C3.30724 14.5262 3.64638 14.6667 4 14.6667H12C12.3536 14.6667 12.6928 14.5262 12.9428 14.2762C13.1929 14.0261 13.3333 13.687 13.3333 13.3333V5.33334L10 1.33334Z'
          stroke='rgba(0, 0, 0, 1)'
          strokeWidth='1'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10 1.33334V5.33334H13.3333'
          stroke='rgba(0, 0, 0, 1)'
          strokeWidth='1'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.6667 8.66666H5.33333'
          stroke='rgba(0, 0, 0, 1)'
          strokeWidth='1'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.6667 11.3333H5.33333'
          stroke='rgba(0, 0, 0, 1)'
          strokeWidth='1'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.66667 6H5.33333'
          stroke='rgba(0, 0, 0, 1)'
          strokeWidth='1'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </div>
  )
}
